module.exports = __webpack_public_path__ + "../resources/images/illustration_junk-422a0c36860cc5ca26a9a8c8f462c8d8.svg";